import Vue from 'vue'
import App from '@/App.vue'
import '@/registerServiceWorker'
import router from '@/router'
import store from '@/store'
import BootstrapVue from "bootstrap-vue"

import Default from '@/Layout/Wrappers/baseLayout.vue';
import Pages from '@/Layout/Wrappers/pagesLayout.vue';

import FontAwesomeIcon from '@/plugins/fontawesome'

Vue.config.productionTip = false

Vue.use(BootstrapVue);

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('default-layout', Default);
Vue.component('userpages-layout', Pages);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
